import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import SvgPolygonDirectiveController from "./SvgPolygonDirectiveController";

import "./SvgPolygon.html";
import "./SvgPolygon.scss";

export default class SvgPolygonDirective implements IDirective {
    public bindToController = {
        create: "=?",
        editable: "=?",
        selectable: "=?",
        editing: "=?",
        onDelete: "&?",
        onEditing: "&?",
        points: "=mmSvgPolygon",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public replace: true;

    public restrict = "A";

    public scope = {};

    public templateNamespace: "svg";

    public templateUrl = "/App/Modules/Gui/Directives/SvgPolygon/SvgPolygon.html";

    constructor() {
        this.controller = SvgPolygonDirectiveController;
    }
}

module("mmGui").directive("mmSvgPolygon", () => new SvgPolygonDirective());
